import { createContext } from "react";
import { User } from "@auth0/auth0-react";

export type AuthType = {
  user: User & { permissions: string[]; roles: string[] };
  getToken: () => unknown;
};

export type AuthContextProps = {
  auth: AuthType | null;
  login: (returnTo?: string) => void;
  logout: () => void;
  authReady: boolean;
};

const initContextData: AuthContextProps = {
  auth: null,
  login: () => null,
  logout: () => false,
  authReady: false
};

export const AuthContext = createContext<AuthContextProps>(initContextData);
